import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'

import osDx from '../functions/osdx';

// "use strict";

// Categorias
const DetalleNivel = props => {
  return (
    <option>{props.elemento.descrCategOST}</option>
  )
};

const ListaCateg = ({styles, handleChange, list}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrCategOST" id="miListaCateg" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

// Tipos de OS
const DetalleNivelTipo = props => {
  return (
    <option dato1={props.elemento.codigoTipoOS} dato2={props.elemento.descrTipoOS} value={props.elemento._id}>{props.elemento.codigoTipoOS} ={">"} {props.elemento.descrTipoOS}</option>
  )
};

const ListaTipo = ({styles, handleChange, list}) => {
    let nuevoList = []
    nuevoList = list.filter(elemento => elemento.estadoCrearOS!=='NUEVO'&&(elemento.estadoCerrarOS==='DESCONECTADO'||
        elemento.estadoCerrarOS==='DESCONECTADO, SUSPENDIDO o RETIRADO'||elemento.descrTipoOS==="DATACREDITO"));

    const NivelDetalleTipo = nuevoList.map((elemento, _id) => <DetalleNivelTipo elemento={elemento} key={elemento._id} />);
    return(
      <div>
        <select style={styles.input} className="ui simple selection dropdown fluid" name="tipoos" id="miLista" onChange={(ev)=>handleChange(ev)}>
          <option style={styles.input} value="">Seleccionar...</option>
          {NivelDetalleTipo}
        </select>
      </div>
    )
};

//Ajustes
const DetAjustes = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.linea}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.observacAB}</td>
    </tr>
  )
};

const ListaAjustes = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetAjustes elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class ProcAdmOSDX extends React.Component {
  state={codigoTipoOS: "", descrTipoOS: "Seleccionar...", descrCategOST: "Seleccionar...",
    listArchivo: [], permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  handleChange = async (ev) => {
    // console.log(ev.target.name, ev.target.value)
    const updState = (listArchivo) => {
      this.setState({listArchivo, errors: []})
    };

    if(ev.target.name === "tipoos"){
      let codigoTipoOS="", descrTipoOS="Seleccionar...", descrCategOST="Seleccionar..."
      let miLista = document.getElementById("miLista");
      if(ev.target.value&&ev.target.value!=="Seleccionar..."){
        codigoTipoOS = miLista.options[miLista.selectedIndex].attributes[0].value
        descrTipoOS = miLista.options[miLista.selectedIndex].attributes[1].value
      }
      this.setState({codigoTipoOS, descrTipoOS, descrCategOST, listArchivo: [], errors: []})
    }
    if(ev.target.name === "descrCategOST"){
      let descrCategOST="Seleccionar..."
      let miLista = document.getElementById("miListaCateg");
      if(ev.target.value&&ev.target.value!=="Seleccionar..."){
        descrCategOST = ev.target.value
      }
      this.setState({descrCategOST})
    }
    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"||ev.target.name === "tipoos"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let fileInput = document.getElementById("csv")
      if(fileInput.files.length>0){
        let allOdeS = []
        if(this.props.allOdeS.allOdeS){
          let {data} = await this.props.allOdeS.refetch({estadoOS: "ABIERTA"})
          allOdeS = await data.allOdeS
        }
        // console.log(this.state.descrTipoOS, allOdeS)
        let descrTipoOS = this.state.descrTipoOS
        let archcsv = ""
        // console.log(fileInput.files[0].name) //Nombre del archivo seleccionado
        let reader = new FileReader();
        reader.onload = function () {
          archcsv = reader.result
          // document.getElementById('out').innerHTML = archcsv;

          //asignar los datos del archivo a archivo
          let archivo = archcsv.toString()
          //guardar en array lines, cada linea del archivo
          let lines = archivo.split(/\n/)
          let numLineas = 0, linea = 0, listArchivo = []
          lines.forEach(line => {
            if(line&&(numLineas>0||(numLineas===0&&!checkTieneEncab))){
              linea += 1
              //crear array de campos para cada linea
              let campos = line.split(";")
              let contrato = campos[0]
              let observacAB = campos[1]
              // let tecnologia = campos[26].substring(0, campos[26].length).replace(/\r/g,'')

              if(allOdeS.length>0&&descrTipoOS!=="Seleccionar..."){
                let lista = allOdeS.filter(elemento => elemento.contrato===contrato && 
                  (elemento.tipoos.descrTipoOS===descrTipoOS||elemento.tipoos.descrTipoOS==="MANTENIMIENTO"||
                    elemento.tipoos.descrTipoOS==="TRASLADO"||elemento.tipoos.descrTipoOS==="MIGRACION TECNOLOGIA"))
              
                let fechaCreate = null
                if(lista.length>0){
                  let fechaInicio = new Date().getTime();
                  let fechaFin = new Date(fechaInicio-(30*1000*60*60*24)+(1000*60*60*24));
                  let fechaValid = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
                  fechaCreate = lista[0].fechaCreate.substring(0, 10)
                  if(fechaCreate.toString()<fechaValid.toString()){
                    fechaCreate = null
                  }
                  for(let ii=0; ii<lista.length; ii++){
                    if(lista[ii].tipoos.descrTipoOS===descrTipoOS){
                      fechaCreate = fechaValid
                    }
                  }
                }
                if(lista.length===0||(lista.length>0&&!fechaCreate)){
                  if(lista.length===0&&descrTipoOS==="SUSPENSION POR PAGO"){
                    lista = allOdeS.filter(elemento => elemento.contrato===contrato && 
                      (elemento.tipoos.descrTipoOS==="DESCONEXION TOTAL"))
                    if(lista.length===0){
                      listArchivo.push({linea, contrato, observacAB})
                    }
                  }else{
                    listArchivo.push({linea, contrato, observacAB})
                  }
                // }else{
                //   console.log(descrTipoOS, contrato, lista)
                }
              }
            }
            numLineas += 1
          })
          updState(listArchivo)
        };
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(fileInput.files[0]);
      }else{
        this.setState({listArchivo: [], errors: []})
      }
    }
  }

  handleSubmit = async (ev, listArchivo, empresaArchFE, lista1)=>{
    let errors = []
    if(listArchivo.length===0){
      errors.push({path: "Clientes", message: "No hay clientes"});
    }
    if(this.state.descrTipoOS==="Seleccionar..."){
      errors.push({path: "descrTipoOS", message: "Por favor seleccione el Tipo de OS"});
    }
    if(this.state.descrCategOST==="Seleccionar..."&&lista1.length>0){
      errors.push({path: "descrCategOST", message: "Por favor seleccione la Categoría del Tipo de OS"});
    }

    let listArchivoIni = listArchivo
    for(let ii=0; ii<listArchivo.length; ii++){
      let elemento = listArchivo[ii]
      if(!elemento.contrato){
        errors.push({path: "Clientes", message: `Contrato NO EXISTE en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}`});
      }

      if(this.props.allClientes.allClientes){
        let {data} = await this.props.allClientes.refetch({contrato: listArchivo[ii].contrato, numDocum: 1327})
        let allClientes = await data.allClientes
        if(allClientes.length===0){
          errors.push({path: 'contrato', message: `Contrato NO EXISTE en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}`});
        }
        if(allClientes.length>0&&allClientes[0].estadoCliente!=="ACTIVO"&&this.state.descrTipoOS!=="DATACREDITO"){
          errors.push({path: 'contrato', message: `Contrato NO se encuentra ACTIVO en línea No. ${elemento.linea} => Contrato: ${elemento.contrato} se encuentra ${allClientes[0].estadoCliente}`});
        }
      }
      if(!elemento.observacAB.trim()){
        errors.push({path: 'observacAB', message: `Línea No. ${elemento.linea} => NO tiene la observación para la OS`});
      }
    }
    listArchivo = listArchivoIni

    this.setState({errors})
    if(errors.length===0){
      //PROCESO CREAR OS DX
      document.body.style.cursor = 'wait'

      let iii = 0, contratoFinProc = listArchivo[listArchivo.length-1].contrato, contratoFin = ""

      const startTime = async (listArchivo, allCli, allTiposOS, allRecurso, editSeqfindOneAndUpdate,
          createOdeS, editOdeSUpdDoc) => {
        let clienteSel = {}, argsSelDpto = {}

        setTimeout(async ()=>{
          // console.log("paso ajuste")
          if(iii<listArchivo.length){
            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha

            if(allCli){
              let {data} = await this.props.allClientes.refetch({contrato: listArchivo[iii].contrato, numDocum: 1327})
              let allClientes = await data.allClientes

              clienteSel = allClientes[0]
              // console.log(clienteSel, allClientes)
              argsSelDpto['codigoTipoDocT'] = clienteSel.dirmayor.ciudades.zonas.barrios.codigoTipoDocT
              argsSelDpto['numeroDocumT'] = clienteSel.dirmayor.ciudades.zonas.barrios.numeroDocumT
              
              argsSelDpto['codigoMarquilla'] = clienteSel.codigoMarquilla?clienteSel.codigoMarquilla:""
              argsSelDpto['descrNodo'] = clienteSel.descrNodo?clienteSel.descrNodo:""
              argsSelDpto['codigoPaquete'] = clienteSel.codigoPaquete?clienteSel.codigoPaquete:""
              argsSelDpto['descrPaquete'] = clienteSel.descrPaquete?clienteSel.descrPaquete:""
            }

            let lista = []
            let tipoOSIns = {}
            if(allTiposOS.allTiposOS){
              lista = allTiposOS.allTiposOS.filter(elemento => elemento.descrTipoOS===this.state.descrTipoOS)
              if(lista.length>0){
                tipoOSIns = lista[0]
                tipoOSIns['_idTipoOS'] = lista[0]._id
              }
            }
            let descrCategOST = this.state.descrCategOST

            let recurso = []
            // console.log(argsSelDpto.codigoTipoDocT, argsSelDpto.numeroDocumT)
            if(allRecurso.allRecurso){
              recurso = allRecurso.allRecurso.filter(elemento =>
                elemento.codigoTipoDoc===argsSelDpto.codigoTipoDocT&&
                elemento.numeroDocum===argsSelDpto.numeroDocumT)
            }

            let contratoAj = await osDx(recurso, listArchivo[iii], argsSelDpto, editSeqfindOneAndUpdate,
              createOdeS, editOdeSUpdDoc, fechaHoraHoy,
              tipoOSIns, descrCategOST)
            contratoFin = contratoAj.contrato

            await startTime(listArchivo, allCli, allTiposOS, allRecurso, editSeqfindOneAndUpdate,
              createOdeS, editOdeSUpdDoc)
            // console.log(iii, "contrato ", contratoFin, contratoFinProc)
            if(contratoFin===contratoFinProc){
              
              setTimeout(async () => {
                this.setState({listArchivo: [], errors: []})
                document.body.style.cursor = 'default'
              }, 2000)

              // console.log("timeout fin", iii)
            }

            iii += 1
          } 
        }, 200);
      }
      await startTime(listArchivo, this.props.allClientes,
                      this.props.allTiposOS, this.props.allRecurso, this.props.editSeqfindOneAndUpdate,
                      this.props.createOdeS, this.props.editOdeSUpdDoc)

    }
    
    console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){

  }

  render(){
    const {descrTipoOS, listArchivo, permiteUpdate, confirmaAct, open,
            errors} = this.state;

    let lista = []
    let lista1 = []
    if(this.props.allTiposOS.allTiposOS){lista = this.props.allTiposOS.allTiposOS}
    if(this.props.allCategOST.allCategOST){lista1 = this.props.allCategOST.allCategOST}
    if(descrTipoOS&&descrTipoOS!=="Seleccionar..."){
      lista1 = lista1.filter(elemento => elemento.descrTipoOS===descrTipoOS)
    }else{
      lista1 = []
    }
  
    let mensaje = "CREAR OS tipo " + descrTipoOS
    let imgIcon = "images/archivo_32.png"

    // let estilos = Object.assign({}, this.props.styles.input, {opacity: 0, cursor: 'pointer'})
    // let estilos = Object.assign({}, this.props.styles.input, {display: "none", cursor: 'pointer'})
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    // let estilos = this.props.styles.input

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large plus yellow icon"></i>
            Procesar archivo
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listArchivo, this.props.empresa.empresaArchFE, lista1):()=>{}}>
              <div>
                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <h1 style={{color: '#2C7744'}}>Procesar archivo de OS DX</h1>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <br/>
                <div className="column">
                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>NO se crea la OS si ya tiene una abierta del mismo tipo o de MANTENIMIENTO, TRASLADO, MIGRACION TECNOLOGIA</label>
                </div>
                <Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={this.props.styles.boxGrid}>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>Crear OS Tipo</label>
                        <ListaTipo list={lista} styles={this.props.styles} handleChange={this.handleChange}/>
                      </div>

                      {lista1.length>0 &&
                        <div className="column" style={this.props.styles.boxGrid}>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>Categoría</label>
                          <ListaCateg list={lista1} styles={this.props.styles} handleChange={this.handleChange}/>
                        </div>
                      }
                    </div>
                  </div>
                </Form.Field>
                <hr></hr>
                <br/>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Seleccionar archivo CSV...&nbsp;&nbsp;
                      </label>

                      <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                      {/* <output id="out" style={estilos1}>
                          file contents will appear here
                      </output> */}
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                  name="checkTieneEncab" onChange={this.handleChange}/>
                          &nbsp;&nbsp;Tiene encabezados en la primera fila
                        </p>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <br/>
                <hr></hr>


                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Totales:  Clientes:&nbsp;
                  {listArchivo.length}
                </p>

                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
                <div style={{height: '40em', overflow: 'auto'}}>
                  <table id="tablaPagos" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                      <th className=''>No.</th>  
                      <th className=''>Contrato</th>
                      <th className=''>Observaciones para OS</th>
                      </tr>
                    </thead>
                    <ListaAjustes list={listArchivo}/>
                  </table>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  graphql(queries.query.allOdeS, {name:'allOdeS', options: (props) => {return {variables: {estadoOS: "ABIERTA"}}}}),

  graphql(queries.query.allTiposOS, {name:'allTiposOS'}),
  graphql(queries.query.allCategOST, {name:'allCategOST'}),
  
  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.createOdeS, {name:'createOdeS'}),
  graphql(queries.mutation.editOdeSUpdDoc, {name:'editOdeSUpdDoc'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProcAdmOSDX)
